import React from "react";
import styles from "./GameScore.module.scss";

interface IGameScoreProps {
  title: string;
  score: number;
}

const GAME_SCORE_PADDING = 8;

const GameScore: React.FC<IGameScoreProps> = ({ title, score }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.score}>
        {score.toString().padStart(GAME_SCORE_PADDING, "0")}
      </div>
    </div>
  );
};

export default GameScore;
